import CopyrightIcon from '@mui/icons-material/Copyright'
import {Button, Grid, Typography} from '@mui/material'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'

import {useNavigate} from 'react-router-dom'
import {useBlur} from 'styles/useStyles'
import {emToAbsoluteUrl} from 'utilities/extensionMethods'
import AppBar from './header/AppBar'

function Home() {
  const blur = useBlur()
  const navigate = useNavigate()
  return (
    <Box sx={{backgroundColor: '#f5f8fa'}}>
      <Box sx={{minHeight: 'calc(100vh - 70px'}}>
        <AppBar />
      </Box>
      <Box maxWidth={'1320px'} margin={'auto'}>
        <Box display={'flex'} flexWrap={'wrap'} width={'100%'}>
          <Card elevation={4} sx={{background: 'transparent', boxShadow: 'none !important'}}>
            <CardHeader
              title={
                <Box display={'flex'} justifyContent={'center'} mt={4}>
                  <Typography variant={'h2'} sx={{fontWeight: 700}}>
                    AI-powered tech scouting & market research
                  </Typography>
                </Box>
              }
            ></CardHeader>
            <CardContent>
              <Grid container>
                <Grid display={'flex'} item xs={12} md={4}>
                  <Box
                    display={'flex'}
                    flexGrow={'1'}
                    justifyContent='center'
                    alignContent={'center'}
                    alignItems={'center'}
                  >
                    <Button
                      variant={'contained'}
                      color={'info'}
                      sx={{borderRadius: '20px'}}
                      onClick={() => navigate('/pricing')}
                    >
                      Sign up now!
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs={12} md={8}>
                  <Box display={'flex'} sx={{maxHeight: '30vh'}}>
                    <Box display={'flex'} overflow={'hidden'}>
                      <img
                        style={{width: '100%', height: 'auto', margin: 'auto'}}
                        alt='Abstract discovery example on iScout'
                        src={emToAbsoluteUrl('/static/screenshots/abstract-discovery_450k.png')}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Grid container>
            <Grid item lg={12}>
              <Box
                display={'flex'}
                flexWrap={'wrap'}
                flexDirection={'row'}
                justifyContent={'space-between'}
                gap={5}
                mt={5}
              >
                <Box display={'flex'} flex={'1 1 auto'}>
                  <Card elevation={0}>
                    <CardHeader title={'Precise Results'}></CardHeader>
                    {/* TODO BLUR-Example  */}
                    {/* <CardContent sx={{backgroundColor: 'white'}} className={blur.blur}>
                      <Typography variant={'subtitle1'}>
                        Tech scouting and market research can be labor intensive, time consuming
                        activities particularly when you are seeking innovative solutions. iScout
                        helps you identify innovative companies with the precise capabilities
                        required to solve your technical challenges. Leveraging a network of over
                        1.5 million businesses, and a knowledge graph with over 40,000 technologies
                        and concepts, iScout takes your scouting and research efforts to a whole new
                        level. Forget having to run numerous keyword searches and wade through
                        irrelevant results in systems with limited, outdated information. iScout
                        allows you to enter a problem statement consisting of a phrase, a paragraph
                        or even multiple pages. The application then instantaneously evaluates your
                        problem statement against millions of businesses, awards and documents and
                        returns the most relevant businesses and content.
                      </Typography>
                      <Button variant={'contained'} className={blur.nomask + ' nomask'}>
                        Hello
                      </Button>
                    </CardContent> */}
                    <CardContent sx={{backgroundColor: 'white'}}>
                      <Typography variant={'subtitle1'}>
                        Tech scouting and market research can be labor intensive, time consuming
                        activities particularly when you are seeking innovative solutions. iScout
                        helps you identify innovative companies with the precise capabilities
                        required to solve your technical challenges. Leveraging a network of over
                        1.5 million businesses, and a knowledge graph with over 40,000 technologies
                        and concepts, iScout takes your scouting and research efforts to a whole new
                        level. Forget having to run numerous keyword searches and wade through
                        irrelevant results in systems with limited, outdated information. iScout
                        allows you to enter a problem statement consisting of a phrase, a paragraph
                        or even multiple pages. The application then instantaneously evaluates your
                        problem statement against millions of businesses, awards and documents and
                        returns the most relevant businesses and content.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
                <Box display={'flex'} flex={'1 1 auto'}>
                  <Card elevation={0}>
                    <CardHeader title={'Project Based'}></CardHeader>
                    <CardContent>
                      <Typography variant={'subtitle1'}>
                        iScout permits you to take a project based approach to scouting and research
                        activities so that you can collect responsive businesses, documents and
                        awards of interest. You and your team members can collaborate on these
                        projects, engage responsive businesses in multi-stage evaluations, upload
                        documents and capture notes related to the businesses and the project, and
                        share results with your customers. We automatically save your prior searches
                        so that you can quickly return to an ongoing search or reuse and revise it
                        for a new activity. Defense organizations or commercial firms can share
                        projects, as well as documents and notes from business assessments, to
                        leverage the work of their peers.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
                <Box display={'flex'} flex={'1 1 auto'}>
                  <Card elevation={0}>
                    <CardHeader title={'Secure and Scalable Design'}></CardHeader>
                    <CardContent>
                      <Typography variant={'subtitle1'}>
                        We designed iScout with security and scalability in mind from the start.
                        iScout resides in AWS Govcloud and utilizes an Enterprise Landing Zone
                        architecture incorporating DevSecOps policies and tools designed to reduce
                        risk, simplify compliance, and integrate security into our continuous
                        integration/continuous delivery (CI/CD) pipeline. iScout includes a robust
                        ETL and machine learning infrastructure that leverages S3, Postgres, Neo4J,
                        Spark and Databricks Lakehouse Platform*. Initially, the system is designed
                        for DoD Impact Level 4 (IL4) data.
                      </Typography>
                    </CardContent>
                  </Card>
                </Box>
              </Box>
              <Box m={3}>
                <Typography>
                  *Our Databricks instance is currently in AWS commercial, but will be moved to AWS
                  Govcloud when Databricks launches that service. For clarification, IL4 data is not
                  utilized or otherwise stored in the Databricks lakehouse.
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid container mt={5} pb={15}>
            <Box display={'flex'} justifyContent={'center'} gap={10}>
              <Box p={3}>
                <Typography variant={'h2'} fontWeight={700}>
                  Transformational graph database access
                </Typography>
                <Typography sx={{fontSize: '1.25rem', fontWeigth: 300}}>
                  Let iScout get to work on tracking down businesses, published papers, and
                  SBIR/STTR grants awarded in your area, so you can find your next steps quicker
                  than ever.
                </Typography>
                <Button
                  variant={'contained'}
                  color={'info'}
                  sx={{borderRadius: '20px'}}
                  onClick={() => navigate('/pricing')}
                >
                  Get started today
                </Button>
              </Box>
              <Box sx={{overflow: 'hidden', maxHeight: '40vh'}}>
                <img
                  style={{borderRadius: '3px'}}
                  src={emToAbsoluteUrl('/static/screenshots/business-results_200k.png')}
                  alt='Business results listing on iScout'
                  width='720'
                />
              </Box>
            </Box>
          </Grid>
        </Box>
      </Box>
      <Box
        style={{
          height: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#181c32',
          color: 'white',
        }}
        className={'text-bg-dark text-center'}
      >
        <CopyrightIcon sx={{mr: 1}} />
        2023
      </Box>
    </Box>
  )
}

export {Home}
